/********************************************************
 *
 * Old interface, for non-backdraft apps
 *
 ********************************************************/

import Application from "shared/application";
import Flash from "shared/flash";
import Ajax from "shared/ajax";
import ExceptionHandling from "shared/logging/exception_handling";

import jQuery from "jquery";

export function ajax(options) {
  const jqOptions = options;
  jqOptions['on_complete'] = jqOptions['complete'];
  jqOptions['complete'] = (xhr, textStatus) => { jqueryAjaxComplete(xhr, options, textStatus); };

  // add the authenticity token for Rails CSRF validating
  jqOptions['data'] = jqOptions['data'] || {};

  const token = Application.getCSRFToken();

  if (typeof jqOptions['data'] === "string") {
    jqOptions['data'] = jqOptions['data'] + jQuery.param({ authenticity_token: token });
  } else {
    jqOptions['data']['authenticity_token'] = token;
  }

  jQuery.ajax(jqOptions);
}

export function jqueryAjaxComplete(xhr, jqOptions, textStatus) {
  let message = "Sorry, an error occurred.";
  let success;
  const options = jqOptions || {};
  let status = null;

  if (textStatus === 'timeout') {
    ExceptionHandling.logWarning("Application.ajax request timed out");
    success = false;
    status = -1;
  } else if (textStatus === 'parsererror') {
    ExceptionHandling.logError(`Parse error on ajax response from url '${options['url']}'. Response: ${xhr.responseText}`);
    // could also listen for "error" callback and log the 'errorThrown' parameter
    success = false;
    status = xhr.status;
  } else {
    const result = Ajax.parseResponse(xhr);
    status = result.status;
    success = result.success;
    message = result.message;

    if (result.textStatus) {
      textStatus = result.textStatus;
    }
  }

  if (!success) {
    if (!options.custom_error_handling && message) {
      Flash.showError(message);
    }

    if (typeof options.error_with_message === "function") {
      options.error_with_message.apply(this, [xhr, message, textStatus, status]);
    }
  }

  if (typeof options.on_complete === "function") {
    options.on_complete.apply(this, [xhr, message]);
  }
}
